import styled from "@mui/material/styles/styled";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import LaunchIcon from "@mui/icons-material/Launch";

const buttonStyle: React.CSSProperties = {
  float: "right",
  cursor: "pointer",
  marginBottom: "1px",
  color: KahunColorMap.Default,
};
buttonStyle["&:hover"] = { color: KahunColorMap.Accent };

export const DeleteIcon = styled(HighlightOffIcon)(({ theme }) => ({
  ...buttonStyle,
}));

export const LaunchButton = styled(LaunchIcon)(({ theme }) => ({
  ...buttonStyle,
}));
